import * as React from 'react'
import { OrderProps, OrdersModuleProps } from './types'
import { ModuleLayout } from '../../components/ModuleLayout'
import { RedirectButton } from '../../components/RedirectButton'
import './index.scss'
import { OrderCard } from '../../components/OrderCard'
import { Spinner } from '@petz/ds-spinner'

export const OrdersModule: React.FC<OrdersModuleProps> = ({ isLogged, orders, loaded, error }) => {
  const status = React.useMemo(() => {
    if (error) return 'error'
    if (!loaded) return 'loading'
    if (!isLogged) return 'no-user'
    if (orders && orders.length > 0) return 'orders'

    return 'no-orders'
  }, [isLogged, orders, loaded, error])

  return (
    <ModuleLayout>
      <div className="orders-container">
        {status === 'error' ? (
          <div className="self-service-error-container">
            <div className="error-image-container">
              <img alt="Imagem de cacto cinza" className="error-image" src="https://static-file.petz.com.br/web-self-service/orders-error.webp" width={148} height={148} />
            </div>
            <div className="error-text-container">
              <p className="error-text">Não foi possível carregar.</p>
              <p className="error-text">Tente novamente mais tarde.</p>
            </div>
          </div>
        ) : null}

        {status === 'loading' ? (
          <div className="spinner-container" data-testid="spinner-container">
            <Spinner background="white" size="lg" />
          </div>
        ) : null}

        {status === 'no-user' ? (
          <div className="self-service-login-container">
            <p className="login-title">Acesse sua conta</p>
            <p className="login-description">Para localizar as informações sobre os seus pedidos e agendamentos, acesse sua conta.</p>
            <div className="login-button-container">
              <RedirectButton title={'Acessar conta'} href={'/checkout/login/indexLogado_Loja'} kind={'solid'} section={'Acompanhar pedido'} subSection={'Acesse sua conta'} />
            </div>
          </div>
        ) : null}

        {status === 'no-orders' ? (
          <div className="self-service-no-orders-container">
            <div className="title-image-container">
              <img alt="Imagem de camaleão" className="no-orders-image" src="https://static-file.petz.com.br/web-self-service/no-orders.webp" width={64} height={64} />
            </div>
            <div className="no-orders-text-container">
              <p className="no-orders-title">Não há pedidos pendentes</p>
              <p className="no-orders-description">Saiba mais acessando o seu histórico.</p>
            </div>
            <div className="login-button-container desktop">
              <RedirectButton
                title={'Ir para Meus pedidos'}
                href={'/petz-pedidos'}
                kind={'text'}
                rightIconName={'arrow-right'}
                section={'Acompanhar pedido'}
                subSection={'Não há pedidos pendentes'}
              />
            </div>
            <div className="login-button-container mobile">
              <RedirectButton
                title={'Ir para Meus pedidos'}
                href={'/petz-pedidos'}
                kind={'outline'}
                rightIconName={'arrow-right'}
                section={'Acompanhar pedido'}
                subSection={'Não há pedidos pendentes'}
              />
            </div>
          </div>
        ) : null}

        {status === 'orders' ? (
          <div className="self-service-orders-container">
            <p className="orders-title">Acompanhar pedido</p>
            <div className="orders-list-container">
              {orders!
                .filter((order) => order.idPedido)
                .map((order: OrderProps) => {
                  return (
                    <OrderCard
                      key={order.idPedido}
                      icon={order.urlIconeAnimado}
                      orderNumber={order.numeroPedido}
                      orderId={order.idPedido}
                      status={order.statusPedido}
                      title={order.descricaoStatusPedido}
                    />
                  )
                })}
            </div>
            <div className="my-orders-button-container">
              <RedirectButton
                title={'Ir para Meus pedidos'}
                href={'/petz-pedidos'}
                kind={'outline'}
                rightIconName={'arrow-right'}
                section={'Acompanhar pedido'}
                subSection={'Acompanhar pedido'}
              />
            </div>
          </div>
        ) : null}
      </div>
    </ModuleLayout>
  )
}
